import React from 'react'
import styled from 'styled-components'

const PimpPageHeaderContainer = styled.div`
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;

  .espace-pimprennelle {
    margin-left: 20px;
    font-size: 9px;
  }

  .ratp-logo {
    flex-grow: 1;
    margin-right: 20px;
    text-align: right;
  }

`
import pimprenelle from '/images/pimprenelle.png'
import logo from '/images/logo.png'

export default function PimpPageHeader() {
  return (
    <PimpPageHeaderContainer>
      <div className="espace-pimprennelle">
        <img src={pimprenelle} alt="Pimprenelle" height="60px"/>
      </div>
      <div className="ratp-logo">
        <img src={logo} alt="RATP" width="50px" height="60px"/>
      </div>
    </PimpPageHeaderContainer>
  )
}
